import React from "react";
import { Helmet } from "react-helmet-async";

export default function HomeLoanPage() {
  return (
    <div className="w-full min-h-screen bg-gray-100 p-4">
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="bg-[#FF6F00] text-white p-6">
          <h2 className="text-2xl font-bold">Apply for a Home Loan</h2>
          <p className="mt-2">Find the perfect home loan with minimal documentation and lower interest rates.</p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
            <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
            <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
          </div>
          <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
          <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Apply Now</button>
        </div>
      </div>
      <div className="mx-auto  overflow-hidden p-6 mt-6">
        <h3 className="text-xl font-bold">Home Loan Eligibility</h3>
        <ul className="list-disc ml-6 mt-2">
          <li><b>Age:</b> 21-65 years (Salaried: 21-58 years, Self-Employed: 25-65 years)</li>
          <li><b>Income:</b> Salaried - Min. Rs. 10,000/month, Self-Employed - Min. Rs. 2,00,000/year</li>
          <li><b>Employment:</b> Salaried - 2-3 years experience, Self-Employed - Min. 3 years experience</li>
          <li><b>Credit Score:</b> A score of 750+ is preferred for approval.</li>
        </ul>
      </div>
      <div className="mx-auto overflow-hidden p-6 mt-6">
        <h3 className="text-xl font-bold">Documentation for Home Loan</h3>
        <h4 className="text-lg font-semibold mt-4">1. Salaried Individuals</h4>
        <ul className="list-disc ml-6 mt-2">
          <li>Form 16</li>
          <li>Employee Identity Card</li>
          <li>3 Months Salary Slip</li>
          <li>6 Months Bank Account Statement</li>
          <li>Duration of Employment Evidence</li>
        </ul>
        <h4 className="text-lg font-semibold mt-4">2. Self-Employed Individuals</h4>
        <ul className="list-disc ml-6 mt-2">
          <li>PAN</li>
          <li>Trade License</li>
          <li>Partnership Deed</li>
          <li>Financial Statement Audited by CA</li>
          <li>Profit & Loss Account Statement</li>
          <li>6 Months Bank Account Statement</li>
        </ul>
        <h4 className="text-lg font-semibold mt-4">3. Documents Required from NRIs</h4>
        <ul className="list-disc ml-6 mt-2">
          <li>Income Proof Documents</li>
          <li>Property Papers</li>
          <li>Sale Deed</li>
          <li>Stamped Agreement of Sale</li>
          <li>No Objection Certificate (NOC)</li>
          <li>Possession Certificate</li>
          <li>Land Tax Receipt</li>
        </ul>
      </div>
    </div>
  );
}
